// monarch routes
export enum AppPath {
	Catalog = '/catalog',
	Home = '/',
	NotFound = '/404',
}

// monolith routes
export enum Route {
	AdminGiving = 'company/reports/giving',
	AdminAwards = '/admin/awards',
	AdminAwardsPending = 'admin/awards/pending',
	AdminBilling = '/company/billing',
	AdminBillingActivity = '/company/billing_activity',
	AdminBonusReports = 'company/bonus_reports',
	AdminConfigurations = 'company/settings/configuration/edit',
	AdminChanges = '/admin/security/data_change_logs',
	AdminCompanyChanges = '/admin/security/data_change_logs/company',
	AdminEarnings = '/company/accounts',
	AdminEmptyIntegration = '/company/integrations/user_managements',
	AdminImportedUsers = '/company/imported_users',
	AdminItems = '/company/catalog_items',
	AdminParticipation = '/company/users/participation',
	AdminRecognition = '/company/reports/bonuses',
	AdminRewards = '/company/rewards?aasm_state=approved&range=all',
	AdminSecurity = '/admin/security/sign_in_logs',
	AdminSettings = '/company/settings/appearance/edit',
	AdminSpend = '/analytics/budget_utilization',
	AdminTotals = '/company/rewards/totals_report',
	AdminUsers = '/company/users',
	AnalyticsEngagement = '/analytics/engagement?role=receiver',
	AnalyticsTotals = '/analytics/bonus_totals?period=',
	AnalyticsOrganization = '/analytics/organization_charts/landing',
	AnalyticsWords = '/analytics/words?custom_property_value=overall',
	SuperAdminManageCompanies = '/super_admin/companies',
	SuperAdminCompanySignUps = '/super_admin/sign_up_activity',
	SuperAdminKyb = '/super_admin/kyb',
	SuperAdminInviteReport = '/super_admin/companies/invite_report',
	SuperAdminCompanyIntegrations = '/super_admin/integrations_dashboards',
	SuperAdminManageUsers = '/super_admin/spoof/new',
	SuperAdminAliasUsers = '/super_admin/alias_users/new',
	SuperAdminManageRewards = '/super_admin/rewards',
	SuperAdminRewardsHealth = '/super_admin/rewards/health_check',
	SuperAdminTangoOrders = '/super_admin/tangocard_orders',
	SuperAdminManuallyFulfilled = '/super_admin/manually_fulfilled_rewards',
	SuperAdminManageCatalog = '/super_admin/items',
	SuperAdminProviders = '/super_admin/catalog/accounts',
	SuperAdminPublicBrands = '/super_admin/catalog/public_brands',
	SuperAdminOutOfStock = '/super_admin/catalog/out_of_stock',
	SuperAdminLint = '/super_admin/catalog/lint',
	SuperAdminUnimplemented = '/super_admin/catalog/unimplemented_brands',
	SuperAdminPromoted = '/super_admin/catalog/promoted',
	SuperAdminInternals = '/super_admin/control_panel',
	SuperAdminMarmonSFTP = '/super_admin/user_management_integrations/marmon_sync',
	SuperAdminRecognitionKVM = '/super_admin/kvms/recognition/giving-rate',
	SuperAdminOneOnOneKVM = '/super_admin/kvms/one-on-one',
	SuperAdminPulseChecksKVM = '/super_admin/kvms/pulse-checks',
	SuperAdminBizyFeedback = '/super_admin/bizy/feedback',
	SuperAdminBizyConversations = '/super_admin/bizy/conversations',
	SuperAdminVideos = '/super_admin/videos',
	SuperAdminEmail = '/super_admin/mailer/index',
	SuperAdminTesting = '/super_admin/testing',
	SuperAdminRewardCertificates = '/super_admin/test/reward_certificates',
	SuperAdminLogoAnalysis = '/super_admin/test/logo_analysis',
	SuperAdminAvatars = '/super_admin/test/avatar',
	SuperAdminIntercom = '/super_admin/intercom_conversations',
	SuperAdminIntegrationErrors = '/super_admin/integration_errors',
	SuperAdminLanguageFeedback = '/super_admin/language_feedbacks',
	SuperAdminBetaFeedback = '/super_admin/beta_feedbacks',
	SuperAdminAnalyticsFeedback = '/super_admin/analytics_chart_feedbacks',
	SuperAdminDonationPayouts = '/super_admin/donation_payouts',
	SuperAdminQualityBotReports = '/super_admin/bonus_quality_bot_reports',
	SuperAdminEvents = '/super_admin/events',
	Integrations = '/company/settings/integrations',
	TechOps = '/tech_ops',
	TechOpsCompany = '/tech_ops/company',
	TechOpsUser = '/tech_ops/user',
}

// external pages
export enum Page {
	DesignSystem = 'https://design.bonus.ly',
	Help = 'https://help.bonus.ly/en/',
	NewFeatures = 'https://help.bonus.ly/en/articles/4076250-product-updates-and-new-features',
}
